/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-21 15:54:46
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-11 21:31:37
 * @FilePath: \baishu_react_ui\src\components\BsyLinkData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";

import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyDataTable from "../BsyDataTable";
import BsyMaskLayer from "../BsyMaskLayer";
import { BsyConfig } from "../../global/BsyConfig";
import BsyFormPane from "../BsyFormPane";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyIconBtn from "../BsyIconBtn";
import { hasEmpty } from "../../utils/hasEmpty";
import _ from "lodash";

export default class BsyLinkQuery extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-link-query",
      allowBlank: !0,
      linkFields: [],
      linkForm: null,
      layoutSize: {},
      itemsPerPage: 20,
      showMode: "one", //单条 多条的显示
      showType: "none", // none 默认模式 label 标题模式
      allowAdd: !1, //是否有创建数据的权限
      cls4FullScreen: "block-fullscreen",
      refType: null,
      onGetFilter: null,
      onRelyDone: null,
      popupFormPath: [],
      ...props,
    });
    this.state = {
      datalist:
        props.showMode != "many" ? (props.value ? props.value : {}) : [],
      formName: "",
    };
    this.form = props.form;
    this.limit = props.showType === "label" ? 10 : 20;
    this.page = 0;
    this.componentKey = "tab";
    this.renderIndex = 0;
    this.isFullScreen = false;
    this.oneWidgetRefs = {};
    this.tableRef = React.createRef();
  }

  getValue = () => {
    return null;
  };

  reload = (a) => {
    const { showMode, showType } = this.options;

    if (_.isEqual(this.filter, a)) {
      return;
    }
    this.filter = a;
    this.page = 0;
    if (showMode === "one") {
      this.loadData();
    } else {
      if (showType === "label") {
        this.loadData();
      } else {
        this.tableRef.current && this.tableRef.current.loadData(true);
      }
    }
  };

  componentDidMount() {
    super.componentDidMount();
    this.page = 0;
    let filter =
      BsyUtils.applyFunc(this, this.options.onGetFilter, [], !1) || {};
    if (BsyUtils.isObjectEmpty(this.state.datalist)) {
      this.reload(filter);
    }
  }

  setValue = (data) => {
    const { showMode } = this.options;
    this.value = data;
    if (BsyUtils.isObjectEmpty(data)) {
      if (showMode === "many") {
        this.setState({
          datalist: [],
          formName: "",
        });
      } else {
        this.setState({
          datalist: {},
        });
      }
    } else {
      if (showMode === "many") {
        this.setState({
          datalist: [...data],
          formName: "",
        });
      } else {
        this.setState({
          datalist: { ...data },
        });
      }
    }
  };

  loadData = (config, cb) => {
    const { limit } = this;
    const { showMode, linkFields, showType } = this.options;

    if (
      BsyUtils.isObjectEmpty(this.filter) ||
      (this.filter &&
        this.filter.hasOwnProperty("cond") &&
        BsyUtils.isObjectEmpty(this.filter.cond))
    ) {
      if (showMode === "many") {
        cb && cb([]);
        this.setState({
          datalist: [],
          formName: "",
        });
      } else {
        this.setState({
          datalist: [],
        });
      }
      return;
    }

    let fields = [...linkFields];
    if (showMode != "many") {
      fields = [];
      BsyUtils.forEach(linkFields, (a1, b1) => {
        fields.push(b1.name);
      });
    }
    if (
      showType === "label" &&
      fields.some((field) => field.name !== "label")
    ) {
      fields.push({
        name: "label",
        text: "标题",
        type: "text",
      });
    }

    let data = {
      designAppId: this.options.designAppId,
      designEntryId: this.options.designEntryId,
      appId: this.options.appId,
      entryId: this.options.entryId,
      formId: this.options.linkForm,
      fields: fields,
      filter: this.filter,
      isNewFilter: this.filter
        ? this.filter.hasOwnProperty("cond")
          ? true
          : false
        : false,
      limit: showMode === "many" ? (config ? config.limit : limit) : undefined,
      skip:
        showMode === "many"
          ? config
            ? config.skip
            : this.page * limit
          : undefined,
      multi: showMode === "many" ? true : undefined,
      refAppId: this.options.refAppId,
      widgetName: this.options.widgetName,
    };
    React.axios(`/data/filter`, data).then((res) => {
      BsyUtils.showAjaxTip(res.data, () => {
        if (showMode === "many") {
          cb && cb(res.data.result, res.data.count);
          if (showType === "label") {
            if (this.page === 0) {
              this.setState({
                datalist: res.data.result,
                formName: res.data.formName,
                count: res.data.count,
              });
            } else {
              this.setState({
                datalist: [...this.state.datalist, ...res.data.result],
                formName: res.data.formName,
                count: res.data.count,
              });
            }
          } else {
            this.setState({
              datalist: res.data.result,
              formName: res.data.formName,
            });
          }
        } else {
          this.setState({
            datalist: res.data.result,
          });
          this.updateAllWidgetValue(res.data.result);
        }
      });
    });
  };

  updateAllWidgetValue = (datalist) => {
    if (datalist) {
      Object.entries(this.oneWidgetRefs).forEach(([name, widgetRef]) => {
        let value = datalist[name];
        widgetRef.setValue?.(value);
      });
    }
  };

  renderField = (item) => {
    const { datalist } = this.state;
    let value = datalist ? datalist[item.name] : "";
    const { appId, dataId, formId } = this.options;

    let config = { ...item };
    config.value = value;
    config.enable = false;
    config.appId = appId;
    config.dataId = dataId;
    config.formId = formId;

    if (config.type === "subform") {
      config.rootElement = this.form ? this.form.element.current : null;
      config = {
        ...config,
        ...{
          subform_create: false,
          subform_insert: false,
          subform_edit: false,
          subform_sort: false,
          subform_delete: false,
          subform_import: false,
          subform_dataload: false,
        },
      };
    }

    config.ref = (el) => (this.oneWidgetRefs[item.name] = el);
    return (
      <div className="link-field">
        <div className="fl-label">{item.text}</div>
        {BsyUtils.createWidget(config)}
        {/* <div className="bsy_form_item_disable" data-watermark={React.language('content.empty')} title={value} >{value}</div> */}
      </div>
    );
  };

  showData = (data) => {
    if (this.getFormMode() === "preview") {
      tipAlert({
        type: "warning",
        msg: React.language("preview.view.data"),
      });
      return;
    }

    const {
      linkFields,
      entryId,
      refAppId,
      linkForm,
      popupFormPath,
      formId,
      appId,
      subform,
      widgetName,
      refType,
      allowAdd,
      designAppId,
      designEntryId,
    } = this.options;

    if (
      window.FX.STATIC.FTOKEN ||
      refType === "aggregate_table" ||
      refType === "etl_table"
    ) {
      var d = {
        data: data,
        fields: linkFields,
        header: linkFields,
        formName: this.state.formName,
      };
      this.onShowData(d);
      return;
    }

    var d1 = BsyUtils.checkRefApp({
      appId: refAppId,
      entryId: linkForm,
      formId: linkForm,
      dataId: data._id,
      autoShowMsg: true,
      popupFormPath: (popupFormPath || []).concat({
        appId: designAppId,
        entryId: designEntryId,
        formId: linkForm,
        subform: subform,
        widgetName: widgetName,
        islinkquery: true,
      }),
    });

    React.axios("/data/dataView", d1, { autoShowMsg: true })
      .then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            var data = { ...res.data, ...d1 };
            data.header = res.data.fields;
            data.multiTabs = res.data.formTabs;
            data.formTabsStyle = res.data.formTabsStyle || {};
            data.fields = res.data.fields;
            data.needFetchViewData = false;
            data.fieldShowRules = res.data.form.fieldShowRules;
            data.subformFieldShowRules = res.data.form.subformFieldShowRules;
            data.items = res.data.form.items;
            data.ptlist = res.data.ptlist;
            data.height = "100%";
            data.entrance = "form";
            data.hasShareBtn = false;
            data.hasCopy = allowAdd ? data.hasCopy : false;
            data.hasFlow = !res.data.hasCoop && res.data.hasFlow;
            data.hasFlowBtn =
              res.data.flow_close ||
              res.data.flow_replace_node ||
              res.data.flow_transfer;
            data.hasFlowLog = res.data.flow_log;
            this.onShowData(data);
          },
          () => {
            var d = {
              data: data,
              fields: linkFields,
              needFetchViewData: false,
              header: linkFields,
              hasShareBtn: false,
              optAuth: null,
              height: "100%",
            };
            this.onShowData(d);
          }
        );
      })
      .catch(() => {
        var d = {
          data: data,
          fields: linkFields,
          needFetchViewData: false,
          header: linkFields,
          hasShareBtn: false,
          height: "100%",
          optAuth: null,
          title: this.state.formName,
        };
        this.onShowData(d);
      });
  };

  onShowData = (config) => {
    var that = this;
    if (this.props.onShowData) {
      this.props.onShowData(config);
    } else {
      let layerRef = null;
      BsyMaskLayer({
        customCls: "fadein-right",
        onMaskClick: (event) => {
          // if (event.target.classList.contains("BsyMaskLayer")) {
          //   layerRef.close();
          // }
        },
        onContentCreate: (ref) => {
          layerRef = ref;
          return (
            <BsyFormPane
              {...config}
              hasShareBtn={false}
              mode={"view"}
              onClose={(status) => {
                layerRef && layerRef.close();
                if (status) {
                  that.reload(that.filter);
                }
              }}
            />
          );
        },
      });
    }
  };

  renderSingeData = () => {
    const { linkFields, showType } = this.options;

    if (showType === "label") {
      const { datalist } = this.state;
      let value = datalist
        ? datalist["label"]
        : datalist[linkFields[0].name]
        ? datalist[linkFields[0].name]
        : "";
      return (
        <div className={"link-field " + showType}>
          <div
            className="bsy_form_item_disable"
            data-watermark={React.language("content.empty")}
            title={value}
            onClick={() => {
              if (!value) {
                return;
              }
              this.showData(datalist);
            }}
          >
            {value ? (
              <span className="item" title={value}>
                {value}
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="field-list" key={BsyUtils.Ids24()}>
        {linkFields.map((e) => {
          return this.renderField(e);
        })}
      </div>
    );
  };

  addData = () => {
    const { ignoreOptAuth, appId, refAppId, linkForm } = this.options;
    let that = this;
    if (window.FX.STATIC.FTOKEN) {
      tipAlert({
        type: "warning",
        msg: React.language("no.operation.authority"),
      });
      return;
    }

    if (this.getFormMode() === "preview") {
      tipAlert({
        type: "warning",
        msg: React.language("preview.create.data"),
      });
      return;
    }

    if (ignoreOptAuth) {
      tipAlert({
        type: "warning",
        msg: React.language("data.manager.create.data"),
      });
      return;
    }
    const data = {
      appId: refAppId ? (refAppId === appId ? appId : refAppId) : appId,
      entryId: linkForm,
    };
    React.axios(
      `/dashboard/app/${data.appId}/entry/${data.entryId}`,
      data
    ).then((res) => {
      BsyUtils.showAjaxTip(
        res.data,
        () => {
          that.creatForm(res);
        },
        () => {}
      );
    });
  };

  creatForm = (res) => {
    let that = this;
    let {
      popupFormPath = [],
      subform,
      widgetName,
      designAppId,
      designEntryId,
    } = this.options;

    const h = res ? res.data.entry : {};

    window.FX.STATIC.appId = h.appId;
    window.FX.STATIC.entryId = h.entryId;
    window.FX.STATIC.INNERLINK = h._id;

    if (!BsyUtils.isObjectEmpty(h.href)) {
      window.FX.STATIC.FORMHREF = h.href;
    } else {
      window.FX.STATIC.FORMHREF = null;
    }

    let formConfig = {
      ...h,
      appId: h.appId,
      entryId: h.entryId,
    };
    formConfig.content.width = 1080;
    formConfig.content.name = h.name;
    formConfig.content.islinkquery = true;
    formConfig.content.designWidgetName = widgetName;
    formConfig.content.designSubformName = subform;

    let layerRef = null;
    BsyMaskLayer({
      customCls: "fadein-right",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("BsyMaskLayer")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <BsyFormPane
            hasHeader={true}
            popupFormPath={popupFormPath.concat({
              appId: designAppId,
              entryId: designEntryId,
              formId: formConfig.formId || formConfig.entryId,
              subform: subform,
              widgetName: widgetName,
              islinkdata: true,
            })}
            formConfig={formConfig}
            mode={"new"}
            entrance={"form"}
            onClose={() => {
              that.renderIndex++;
              const filter = _.cloneDeep(that.filter);
              that.filter = null;
              that.reload(filter);
              layerRef && layerRef.close();
            }}
          />
        );
      },
    });
  };

  renderManyData = () => {
    const {
      linkFields,
      linkForm,
      entryId,
      appId,
      showType,
      cls4FullScreen,
      allowAdd,
    } = this.options;
    const { datalist, formName, count } = this.state;

    let fields = [];
    BsyUtils.forEach(linkFields, (a1, b1) => {
      if (b1.type === "subform") {
        let subform = { ...b1 };
        let items = [];
        BsyUtils.forEach(b1.items, (a2, b2) => {
          let g = BsyUtils.getFieldAttr(b2, BsyConfig().LimitFields.list, "");
          if (g) {
            g = {
              ...g,
              ...{
                subform: b1.name,
                id: linkForm,
              },
            };
            items.push(g);
          }
        });
        subform.items = items;
        fields.push(subform);
      } else {
        fields.push(b1);
      }
    });

    if (showType === "label") {
      // let value = datalist ? datalist['label'] : '';
      return (
        <div
          className={"link-field " + showType}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <>
            <div
              className="bsy_form_item_disable show-many-label"
              data-watermark={React.language("content.empty")}
            >
              <div className="link-field-content">
                {this.isEnabled() && allowAdd ? (
                  <BsyIconBtn
                    title={React.language("create")}
                    click={this.addData}
                    type={"white"}
                    iconName={"icon-bsy-add"}
                  ></BsyIconBtn>
                ) : (
                  ""
                )}
                {datalist
                  .filter((data) => !hasEmpty(data?.label))
                  .map((e, k) => {
                    return (
                      <span
                        key={k}
                        className={
                          "item" +
                          (k ===
                          datalist.filter((data) => !hasEmpty(data?.label))
                            .length -
                            1
                            ? " last"
                            : "")
                        }
                        title={e.label}
                        onClick={(event) => {
                          event.stopPropagation();
                          event.preventDefault();
                          this.showData(e);
                        }}
                      >
                        {e.label}
                      </span>
                    );
                  })}
                {
                  <span
                    className="load-more"
                    style={{
                      display:
                        datalist.length < count &&
                        this.options.showMode === "many"
                          ? ""
                          : "none",
                    }}
                    title={React.language("more")}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      if (
                        datalist.length < count &&
                        this.options.showMode === "many"
                      ) {
                        this.page += 1;
                        this.loadData(null, () => {
                          setTimeout(() => {
                            event.target.closest(
                              ".bsy_form_item_disable"
                            ).scrollTop = event.target.closest(
                              ".link-field-content"
                            ).offsetHeight;
                          }, 60);
                        });
                      }
                    }}
                  >
                    <i className="icon-bsy-icongengduo1"></i>
                  </span>
                }
              </div>
            </div>
          </>
        </div>
      );
    }
    return (
      <div
        className={this.isFullScreen ? cls4FullScreen : ""}
        // key={"many" + this.renderIndex}
      >
        <div className="query-menu">
          <div className="form-name">{formName}</div>
          <div className="right">
            <div className="add">
              <i
                className={this.isFullScreen ? "icon-shrink" : "icon-enlarge"}
                onClick={() => {
                  this.isFullScreen = !this.isFullScreen;

                  const brot = BsyUtils.closestClass(this.element.current, "bsy-frame-content");
                  if(brot) {
                    const leftMenu = document.querySelector(".bsy-frame-menu");
                    if (leftMenu) {
                      if (this.isFullScreen) {
                        leftMenu.style.display = "none";
                      } else {
                        leftMenu.style.display = "";
                      }
                    }
                  }


         

                  this.setState({});
                }}
              ></i>
            </div>
            {this.isEnabled() && allowAdd ? (
              <div className="add split">|</div>
            ) : (
              ""
            )}
            {this.isEnabled() && allowAdd ? (
              <div className="add new" onClick={this.addData}>
                <i class="icon-bsy-add"></i>
                {React.language("create")}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <BsyDataTable
          widgetId={
            "batch-peview-table-" +
            [this.options.subform, this.options.widgetName].join(".")
          }
          autoRefresh={{ enabled: true }}
          isDash={true}
          ref={this.tableRef}
          sortIncludedField={[]}
          forms={[linkForm]}
          entryId={entryId}
          appId={appId}
          fields={fields}
          skip={this.skip || 0}
          hasCount={false}
          key={this.componentKey}
          hasAutoHeightCache={false}
          onShowData={(e) => {
            this.showData(e);
            // console.log(e);
            // alert("点击单行数据")
          }}
          onDataGet={(url, config, cb) => {
            this.loadData(config, (res, count) => {
              let resd = {
                count: count,
                header: fields,
                data: res,
              };
              cb && cb({ data: resd });
            });
          }}
        />
      </div>
    );
  };

  render() {
    const { cssName, showMode, cls4FullScreen } = this.options;

    return (
      <div
        ref={this.element}
        className={
          cssName +
          (showMode === "many" && this.isFullScreen ? " " + cls4FullScreen : "")
        }
      >
        {showMode === "many" ? this.renderManyData() : this.renderSingeData()}
      </div>
    );
  }
}
